// Module
var code = "<div class=\"tc-container\">\n  <t-container :size=\"size\">\n    <slot></slot>\n  </t-container>\n</div>\n";
// Exports
export default code;